import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import SleepBanner from "../../assets/audio/sleep-banner.png";
import { GetAllSleepCategoriesApi } from "../../services/Api";

const SleepHome = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await GetAllSleepCategoriesApi();
      if (response && response.data) {
        setCategories(response.data);
      }
    };
    fetchCategories();
  }, []);

  const handleCardClick = (category) => {
    navigate("/sleep", {
      state: {
        sleepCategoryId: category.sleepCategoryId,
        sleepCategoryTitle: category.sleepCategoryTitle,
        sleepCategoryImageUrl: category.sleepCategoryImageUrl,
      },
    });
  };

  return (
    <div className="page-container relative bg-white min-h-screen">
      {/* Header */}
      <Header />

      {/* Banner */}
      <div className="w-[40%] mx-auto mt-6 mb-10">
        <img
          src={SleepBanner}
          alt="Sleep Banner"
          className="w-full h-auto object-cover rounded-lg shadow-md"
        />
      </div>

      {/* Sleep Categories */}
      <div className="w-[40%] mx-auto mb-12">
        <h2 className="text-3xl font-bold mb-6 text-center">Sleep Wellness</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {categories.map((category) => (
            <div
              key={category.sleepCategoryId}
              className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer transition-transform hover:scale-105"
              onClick={() => handleCardClick(category)}
              style={{ height: "180px" }}
            >
              <div className="h-[100px] flex items-center justify-center p-2">
                <img
                  src={category.sleepCategoryImageUrl}
                  alt={category.sleepCategoryTitle}
                  className="max-h-full w-full object-contain"
                />
              </div>
              <div className="p-2 text-center">
                <h3 className="text-lg font-bold text-gray-800 truncate">
                  {category.sleepCategoryTitle}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SleepHome;
